import * as React from 'react';
export const Placeholder = ({ serverUrl, instanceId, noPrerender, prerenderContent, loader, }) => {
    const props = {
        'data-mf-id': instanceId,
        'data-mf-role': 'placeholder',
        'data-mf-url': noPrerender ? undefined : serverUrl,
    };
    if (prerenderContent) {
        return React.createElement("div", { ...props, dangerouslySetInnerHTML: { __html: prerenderContent } });
    }
    return (React.createElement("div", { ...props },
        React.createElement("div", { "data-mf-id": instanceId, "data-mf-role": "loader" }, loader)));
};
